import { get } from '@alltrails/shared/api';

const localizeContent = (tableId: string, columnName: string, rowId: string, locale: string) => {
  return get(`/api/alltrails/localizations?table=${tableId}&columnName=${columnName}&rowId=${rowId}`);
};

export { localizeContent };
